import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpProgressEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ItemsService {
  public _http: HttpClient;
  public baseUrlLocal: string = "";

  constructor(private http: HttpClient) {
      this._http = http;
      this.baseUrlLocal = environment.apiBaseUrl;
  }

  uploadExcelFile(file: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('file', file);

    return this._http.post(`${this.baseUrlLocal}excel/upload`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }
}